import {useEffect} from 'react';

let isEventBind = false;
const callBacks = new Map<number, (event: Event) => void>();
let nextId = 1;

const updateCallbacks = (e: Event) => {
	callBacks.forEach((c) => c(e));
};

export const useScroll = () => {
	useEffect(() => {
		if (!isEventBind) {
			window.addEventListener('scroll', updateCallbacks, {
				passive: true
			});
			isEventBind = true;
		}
	}, []);

	return {
		onScroll: (callback) => {
			const id = nextId++;
			callBacks.set(id, callback);

			return id;
		},
		unBind: (id) => {
			callBacks.delete(id as number);
		}
	};
};

export default useScroll;
